import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 6, viewBox: "0 0 9 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.33008 6L8.66021 0L-4.91142e-05 0L4.33008 6Z", fill: "#222222" }));
const ForwardRef = forwardRef(SvgTriangleArrow);
export default ForwardRef;
